import { FeatureService } from "./../../../services/catalogs/FeatureService";
import { CreateDriverDto } from "../../../dtos/catalogs/driver/CreateDriverDto";
import React from "react";
import { FeatureDetail } from "../../../components/Pages/Catalogs/Feature/FeatureDetail";
import { CatalogService } from "../../../services/catalogs/CatalogService";
import { IAppEntity } from "../../entities";
import { ReferenceTypes } from "../../../enums/ReferenceTypes";
import { NFLookupFeature } from "../../../components/Shared/NewForms/NFLookupFeature";
import FeatureList from "../../../components/Pages/Catalogs/Feature/FeatureList";

export const Feature: IAppEntity = {
  entityType: "catalog",
  title: "Feature",
  pluralTitle: "Feature",
  apiUrl: "Features",
  apiEnum: ReferenceTypes.CatalogFeature,
  getDetailViewComponent(
    model: any,
    modelUpdatedEvent: (model: any) => void
  ): any {
    return React.createElement(FeatureDetail, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    });
  },
  getListView: (model: any, modelUpdatedEvent: (model: any) => void) =>
    React.createElement(FeatureList, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    }),
  getLookupComponent(model: any): any {
    return React.createElement(NFLookupFeature, {
      fieldName: model.fieldName,
      title: model.title,
      setSelectedCatalog: model.setSelectedCatalog,
    });
  },
  getDataService() {
    return new FeatureService(this.apiUrl);
  },
  getEmptyModel(): CreateDriverDto {
    return {
      name: "",
      createdDate: new Date(),
    };
  },
};
